"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי לבית המטופל?",
  answer: "אנו מתחייבים למתן מענה מהיר במיוחד. ברוב המקרים, אנו מצליחים להציב מטפל סיעודי מקצועי בבית המטופל בתוך 5 שעות בלבד מרגע הפנייה הראשונית, כדי להבטיח רצף טיפולי ובטחון מלא."
}, {
  question: "האם המטפלים שלכם עוברים הכשרה מקצועית?",
  answer: "בהחלט. כל המטפלים בצוות שלנו עוברים תהליך מיון קפדני והכשרות מקצועיות בתחומי הסיעוד, העזרה הראשונה והתמיכה הרגשית. אנו שמים דגש על ניסיון קודם והמלצות מוכחות."
}, {
  question: "אילו שירותים כלולים בטיפול הסיעודי הביתי?",
  answer: "השירות כולל סיוע בפעולות היומיום (ADL), השגחה צמודה, מתן תרופות, ליווי לבדיקות רפואיות, סיוע בהיגיינה אישית ותמיכה רגשית וחברתית המותאמת לצרכי המטופל."
}, {
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: "כן, המוקד שלנו פעיל 24/7 ואנו מספקים שירותי סיעוד בכל ימות השנה, כולל שבתות וחגים, מתוך הבנה שצורך סיעודי יכול להתעורר בכל רגע נתון."
}, {
  question: "איך מתבצעת ההתאמה בין המטפל למטופל?",
  answer: "אנו מבצעים אבחון טלפוני מהיר להבנת המצב הרפואי והעדפות האישיות של המטופל. על בסיס זה, אנו מתאימים את המטפל בעל הכישורים והאישיות המתאימים ביותר ליצירת חיבור מוצלח."
}, {
  question: "האם אתם עובדים עם חברות הביטוח או קופות החולים?",
  answer: "אנו מספקים שירות פרטי ומהיר, ומנפיקים קבלות המוכרות לצורך החזרים מול פוליסות ביטוח סיעודי פרטיות. אנו ממליצים לבדוק את תנאי הפוליסה האישית שלכם לקבלת פרטים מדויים."
}, {
  question: "מה קורה אם המטפל אינו מתאים למטופל?",
  answer: "שביעות הרצון שלכם היא בראש סדר העדיפויות שלנו. במידה ואין כימיה או התאמה, אנו נדאג להחלפת המטפל במהירות האפשרית כדי להבטיח שהמטופל ירגיש בנוח ובטוח."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: accordionRef,
    isVisible: isAccordionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="260338" id="שאלות-נפוצות" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div ref={headerRef} className={`mb-12 text-center transition-all duration-700 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary sm:text-4xl md:text-5xl mb-4">
            שאלות נפוצות
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-default">
            ריכזנו עבורכם תשובות לשאלות הנפוצות ביותר בנושא שירותי סיעוד מיידיים והתאמת מטפלים.
          </p>
        </div>

        <div ref={accordionRef} className={`transition-all duration-700 delay-200 ease-out ${isAccordionVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-border">
                <AccordionTrigger className="font-default text-right text-lg font-semibold text-foreground hover:text-secondary transition-colors py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}